import React, { Component } from 'react';

import { getLangData, createLink } from "../services/lang";
import { Link } from 'react-router-dom';

class Imprint extends Component {

    render() {

        const langData = getLangData();

        return (
            <div className="container">

                <div className="row mb-5">
                    <div className="col">
                        <p className="h1 fw-300">{langData.imprint.header}</p>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col">
                        <p>
                            Avenue Jeanne 14<br />
                            1050 Bruxelles<br />
                            Belgium
                        </p>
                        <p>
                            <a href="https://susannekleinestate.com">susanne-klein-estate.org</a><br />
                            <Link className="mr-2" to={createLink('/contact')} >{langData.contact.header2}</Link>
                        </p>
                        <p>
                            {langData.imprint.executor}:<br />
                            Peter Klein
                        </p>
                        <p>
                            {langData.imprint.coordinators}:<br />
                            Brooke Ferguson & George Rippon
                        </p>
                        <p>
                            {langData.imprint.designWebsite}:<br />
                            <a href="https://kpelz.eu" target="_blank" rel="noopener noreferrer">Konstantin Pelz</a>
                        </p>
                        <p dangerouslySetInnerHTML={{ __html: langData.meta.imprintEnd }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Imprint;